<template lang="pug">
#modal-vinculo-manual-recebimentos-ar
    el-dialog.modal-vinculo-manual-recebimentos-ar(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        append-to-body,
        custom-class='modal-vinculo-manual-recebimentos-ar-content',
        width='90%'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.titulo') }}

        .modal-vinculo-manual-recebimentos-ar__body
            el-alert(
                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.descricao")',
                type='warning',
                show-icon,
                :closable='false'
            )

            .modal-vinculo-manual-recebimentos-ar__summary
                .summary-item
                    strong {{ recebimentos.length }}
                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.recebimentosPendentes') }}
                .summary-item
                    strong {{ totalVinculados }}
                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.vinculosSelecionados') }}

            .modal-vinculo-manual-recebimentos-ar__workspace
                aside.modal-vinculo-manual-recebimentos-ar__recebimentos
                    h4 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.recebimentos') }}
                    button.recebimento-item(
                        v-for='recebimento in recebimentos',
                        :key='recebimento.idItem',
                        type='button',
                        :class='{ "recebimento-item--active": recebimento.idItem === activeRecebimentoId, "recebimento-item--done": vinculos[recebimento.idItem] }',
                        @click='selecionarRecebimento(recebimento.idItem)'
                    )
                        span.recebimento-item__title {{ recebimento.numeroTicketSalida || '-' }}
                        span.recebimento-item__meta {{ recebimento.codigoInterno || '-' }}
                        el-tag(
                            size='mini',
                            :type='vinculos[recebimento.idItem] ? "success" : "warning"'
                        ) {{ vinculos[recebimento.idItem] ? $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.vinculado') : $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.pendente') }}

                section.modal-vinculo-manual-recebimentos-ar__main(v-if='recebimentoAtivo')
                    .dados-planilha
                        .section-header
                            i.el-icon-document
                            h4 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.dadosPlanilha') }}

                        .dados-planilha__grid
                            .dados-planilha__item
                                span.label ID_INTERNO
                                span.value {{ recebimentoAtivo.codigoInterno || '-' }}
                            .dados-planilha__item
                                span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.codigoPlantaOncca') }}
                                span.value {{ recebimentoAtivo.codigoPlantaOncca || '-' }}
                            .dados-planilha__item
                                span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.codigoNomePuerto') }}
                                span.value {{ recebimentoAtivo.codigoNomePuerto || '-' }}
                            .dados-planilha__item
                                span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.puerto') }}
                                span.value {{ recebimentoAtivo.puerto || '-' }}
                            .dados-planilha__item
                                span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.numeroTicketSalida') }}
                                span.value {{ recebimentoAtivo.numeroTicketSalida || '-' }}
                            .dados-planilha__item
                                span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.numeroCartaPorte') }}
                                span.value {{ recebimentoAtivo.numeroCartaPorte || '-' }}
                            .dados-planilha__item
                                span.label nro CTG
                                span.value {{ recebimentoAtivo.nroCtg || '-' }}
                            .dados-planilha__item
                                span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.tnDescargadosPuertos') }}
                                span.value {{ recebimentoAtivo.tnDescargadosPuertos || '-' }}

                    .selecao-territorios
                        .section-header
                            i.el-icon-location-outline
                            h4 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.selecaoTerritorios') }}

                        el-input(
                            v-model='filtroBusca',
                            :placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.placeholderBusca")',
                            clearable,
                            @input='resetarPaginacao',
                            @clear='resetarPaginacao'
                        )
                            el-button(slot='append', icon='el-icon-search') {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscar') }}

                        el-table.territorios-table(
                            :key='`territorios-${activeRecebimentoId}`',
                            :data='territoriosPaginados',
                            border,
                            stripe,
                            style='width: 100%'
                        )
                            el-table-column(width='56', align='center')
                                template(slot-scope='scope')
                                    el-checkbox(
                                        :value='isTerritorioSelecionado(scope.row.idTerritorio)',
                                        @change='selecionarTerritorio(scope.row)'
                                    )
                            el-table-column(label='Código Lyra', min-width='130')
                                template(slot-scope='scope') {{ scope.row.codigoLyra || '-' }}
                            el-table-column(label='ID Interno', min-width='120')
                                template(slot-scope='scope') {{ scope.row.idInterno || '-' }}
                            el-table-column(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.produtor")',
                                min-width='180'
                            )
                                template(slot-scope='scope') {{ scope.row.produtor || '-' }}
                            el-table-column(label='CUIT', min-width='140')
                                template(slot-scope='scope') {{ scope.row.cuit || '-' }}
                            el-table-column(label='RENSPA', min-width='150')
                                template(slot-scope='scope') {{ scope.row.renspa || '-' }}

                        .territorios-empty(v-if='!territoriosFiltrados.length')
                            el-empty(
                                :description='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.semTerritorios")',
                                :image-size='80'
                            )

                        .c-pagination(v-if='territoriosFiltrados.length')
                            el-pagination(
                                background,
                                :page-size='pageCount',
                                :pager-count='5',
                                :current-page.sync='paginaAtual',
                                layout='prev, pager, next',
                                :total='territoriosFiltrados.length',
                                @current-change='mudarPagina'
                            )

        footer.modal-vinculo-manual-recebimentos-ar__footer(slot='footer')
            el-button(@click='fecharModal', :disabled='carregando') {{ $t('mensagens.comuns.voltar') }}
            el-tooltip(
                v-if='!todosVinculados',
                effect='dark',
                :content='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.confirmeTodos")',
                placement='top'
            )
                span
                    el-button(type='primary', disabled) {{ $t('mensagens.comuns.confirmar') }}
            el-button(
                v-else,
                type='primary',
                :loading='carregando',
                @click='confirmarVinculos'
            ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
export default {
    name: 'ModalVinculoManualRecebimentosAr',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        recebimentos: {
            type: Array,
            default: () => []
        },
        territorios: {
            type: Array,
            default: () => []
        },
        carregando: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            activeRecebimentoId: null,
            filtroBusca: '',
            paginaAtual: 1,
            pageCount: 4,
            vinculos: {}
        };
    },

    computed: {
        recebimentoAtivo() {
            return this.recebimentos.find(
                recebimento => recebimento.idItem === this.activeRecebimentoId
            );
        },

        territoriosFiltrados() {
            const busca = this.filtroBusca.toString().trim().toLowerCase();

            if (!busca) {
                return this.territorios;
            }

            return this.territorios.filter(territorio => {
                const campos = [
                    territorio.codigoLyra,
                    territorio.idInterno,
                    territorio.cuit,
                    territorio.produtor
                ];

                return campos.some(campo =>
                    campo
                        ? campo.toString().toLowerCase().includes(busca)
                        : false
                );
            });
        },

        territoriosPaginados() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.territoriosFiltrados.slice(inicio, fim);
        },

        totalVinculados() {
            return Object.keys(this.vinculos).length;
        },

        todosVinculados() {
            return (
                this.recebimentos.length > 0 &&
                this.totalVinculados === this.recebimentos.length
            );
        }
    },

    watch: {
        show(value) {
            if (value) {
                this.inicializarModal();
            }
        }
    },

    methods: {
        inicializarModal() {
            this.vinculos = {};
            this.filtroBusca = '';
            this.paginaAtual = 1;
            this.activeRecebimentoId = this.recebimentos.length
                ? this.recebimentos[0].idItem
                : null;
        },

        selecionarRecebimento(recebimentoId) {
            this.activeRecebimentoId = recebimentoId;
            this.resetarPaginacao();
        },

        selecionarTerritorio(territorio) {
            if (!this.activeRecebimentoId) {
                return;
            }

            this.$set(this.vinculos, this.activeRecebimentoId, territorio);
        },

        isTerritorioSelecionado(idTerritorio) {
            const territorioSelecionado = this.vinculos[this.activeRecebimentoId];

            return Boolean(
                territorioSelecionado &&
                territorioSelecionado.idTerritorio === idTerritorio
            );
        },

        resetarPaginacao() {
            this.paginaAtual = 1;
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },

        confirmarVinculos() {
            if (!this.todosVinculados) {
                return;
            }

            const payload = this.recebimentos.map(recebimento => ({
                idItem: recebimento.idItem,
                idTerritorio: this.vinculos[recebimento.idItem].idTerritorio
            }));

            this.$emit('confirmar', payload);
        },

        fecharModal() {
            if (this.carregando) {
                return;
            }

            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
.modal-vinculo-manual-recebimentos-ar-content {
    max-width: 1180px;

    .el-dialog__header {
        padding: 20px;
        padding-bottom: 12px;
        padding-top: 12px;
        background: var(--primary) !important;
        color: var(--white);
    }

    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }

    .modal-vinculo-manual-recebimentos-ar__body {
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-height: 70vh;
        overflow-y: auto;
        padding-right: 4px;
    }

    .modal-vinculo-manual-recebimentos-ar__summary {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }

    .modal-vinculo-manual-recebimentos-ar__workspace {
        display: grid;
        grid-template-columns: 260px minmax(0, 1fr);
        gap: 16px;
        min-height: 460px;
    }

    .modal-vinculo-manual-recebimentos-ar__recebimentos {
        display: flex;
        flex-direction: column;
        gap: 10px;
        min-width: 0;
        padding: 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background: #fbfbfb;

        h4 {
            margin: 0 0 4px;
            font-weight: 700;
        }
    }

    .modal-vinculo-manual-recebimentos-ar__main {
        display: flex;
        flex-direction: column;
        gap: 16px;
        min-width: 0;
    }

    .modal-vinculo-manual-recebimentos-ar__footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;

        span {
            display: inline-flex;
        }
    }

    .summary-item {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background: #fbfbfb;

        strong {
            color: var(--primary);
            font-size: 22px;
            line-height: 1;
        }

        span {
            color: #6b7280;
            font-size: 12px;
            font-weight: 600;
        }
    }

    .recebimento-item {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 4px 8px;
        width: 100%;
        padding: 10px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background: #ffffff;
        text-align: left;
        cursor: pointer;

        &:hover,
        &--active {
            border-color: var(--primary);
            box-shadow: 0 0 0 1px rgba(34, 139, 34, 0.12);
        }

        &--done {
            background: #f5fbf7;
        }

        &__title,
        &__meta {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__title {
            font-weight: 700;
        }

        &__meta {
            grid-column: 1 / -1;
            color: #6b7280;
            font-size: 12px;
        }
    }

    .dados-planilha,
    .selecao-territorios {
        padding: 14px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background: #ffffff;
    }

    .section-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        i {
            color: var(--primary);
            font-size: 18px;
        }

        h4 {
            margin: 0;
            font-weight: 700;
        }
    }

    .dados-planilha__grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 10px;
    }

    .dados-planilha__item {
        display: flex;
        flex-direction: column;
        min-width: 0;
        padding: 8px;
        border-radius: 4px;
        background: #f8fafc;

        .label {
            color: #6b7280;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
        }

        .value {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
        }
    }

    .territorios-table {
        margin-top: 12px;
    }

    .territorios-empty {
        margin-top: 12px;
    }

    .c-pagination {
        margin-top: 16px;
        text-align: center;
    }
}

@media (max-width: 900px) {
    .modal-vinculo-manual-recebimentos-ar-content {
        width: 96% !important;

        .modal-vinculo-manual-recebimentos-ar__workspace,
        .modal-vinculo-manual-recebimentos-ar__summary,
        .dados-planilha__grid {
            grid-template-columns: 1fr;
        }

        .modal-vinculo-manual-recebimentos-ar__workspace {
            min-height: auto;
        }
    }
}
</style>
